import $ from 'jquery'
import RytmWebflow from 'rytm-webflow'
import { TweenMax, Elastic, Expo, Sine } from 'gsap'
import imagesLoaded from 'imagesloaded'
import { trace } from 'rytm-helpers'
import AmznController from './AmznController'

import { initOwlCarousel, destroyOwlCarousel } from './../shared/owl-carousel'

let randomizeTimeout

class ContextController extends AmznController {
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    // init owl carousels
    this.initOwlCarousels()
    imagesLoaded(this.getContainerSelector(), $.proxy(this.amznLoadImagesComplete, this));
  }
  /**
  * on view hidden - animation hidden complete
  * @param {Event} e
  **/
  onViewHidden(e) {
    super.onViewHidden(e)
    this.destroyOwlCarousels()
  }

  addEventListeners() {
    $(window).on('resize', $.proxy(this.onWindowResize, this));
    $("body").on("mousewheel", $.proxy(this.onMouseWheel, this))
  }
  removeEventListeners() {
    $(window).off('resize', $.proxy(this.onWindowResize, this));
    $("body").off("mousewheel", $.proxy(this.onMouseWheel, this))
  }

  // AaznController overrides
  amznLoadImagesComplete(e) {
    this.randomizeObjectPositions()
  }

  /**
   * #####################
   * ### OWL CAROUSELS ###
   */
  onMouseWheel(e) {
    const delta = e.originalEvent.wheelDelta
    if (this.carousel) {
      if (delta < 0) {
        this.carousel.trigger('next.owl')
      } else {
        this.carousel.trigger('prev.owl')
      }
    }
  }

  randomizeObjectPositions() {
    // trace("randomize positions")
    clearTimeout(randomizeTimeout)
    randomizeTimeout = setTimeout(() => {
      const list = [...document.querySelectorAll(".amznobj-box")]
      list.forEach(this.randomizeObjectPosition.bind(this))
    }, 800)
  }
  randomizeObjectPosition(el, index) {
    const inner = el.querySelector(".inner")
    if (!inner) {
      return
    }
    const outerRect = el.getBoundingClientRect()
    const rect = inner.getBoundingClientRect()
    const maxY = outerRect.height - rect.height
    const rand = Math.random() * (maxY * .1) - maxY * .01
    const marginY = Math.abs(maxY * .7 * Math.sin(index)) + rand
    // inner.style.marginBottom = marginY + "px"
    TweenMax.to(inner, .6, {marginBottom: marginY + "px", ease: Expo.easeOut })
  }
  unsetObjectPositions() {
    // trace("unser positions")
    const list = [...document.querySelectorAll(".amznobj-box")]
    list.forEach(this.unsetObjectPosition.bind(this))
  }
  unsetObjectPosition(el, index) {
    const inner = el.querySelector(".inner")
    if (!inner) {
      return
    }
    inner.style.marginBottom = 0
  }

  onWindowResize(e) {
    if (window.innerWidth < 768) {
      if (this.carouselInited) {
        this.destroyOwlCarousels()
        this.unsetObjectPositions()
      }
    } else {
      if (!this.carouselInited) {
        this.initOwlCarousels()
      } else {
        this.randomizeObjectPositions()
      }
    }
  }
  getOwlCarouselElements() {
    let list = []
    const container = document.querySelector(this.getContainerSelector())
    if (container) {
      list = [...container.querySelectorAll('.context-carousel')]
    }
    return list
  }
  /**
   * Zwraca parametry owlcarousel
   * @return {*}
   */
  getOwlCarouselParams(el) {
    const autoplay = el.dataset.autorotate ? true : false
    const loop = el.dataset.loop ? true : false
    return {
      nav: true,
      navText: [
        '<img src="/local/images/arrow_left.svg" alt="poprzedni" />', 
        '<img src="/local/images/arrow_right.svg" alt="następny" />'
      ],
      loop: loop,
      margin: 0,
      center: false,
      dots: false,
      autoplay: autoplay,
      autoplayTimeout: 3000,
      autoplaySpeed: 800,
      autoplayHoverPause: true,
      responsive: {
        0: {
          items: 0,
        },
        576: {
          items: 0,
        },
        768: {
          items: 2,
        },
        992: {
          items: 3,
        },
        1380: {
          items: 4,
        },
        1800: {
          items: 5,
        },
      }
    }
  }

  initOwlCarousels() {
    if (window.innerWidth < 768) {
      return
    }
    const list = this.getOwlCarouselElements()
    list.forEach((el) => {
      const params = this.getOwlCarouselParams(el)
      this.carousel = initOwlCarousel(el, params)
    })
    this.carouselInited = true
  }
  destroyOwlCarousels() {
    const list = this.getOwlCarouselElements()
    list.forEach((el) => {
      destroyOwlCarousel(el)
    })
    this.carouselInited = false
  }


}

export default ContextController;